export default __webpack_public_path__ + "static/media/TAYCM-logo.41b92f12.png";